import { BaseApiService } from './base.service';
import {
  AnalyticsDashboard,
  MonitoringDashboard
} from '../../types/api';

/**
 * Service for analytics and monitoring
 */
export class AnalyticsService extends BaseApiService {
  async getAnalyticsDashboard(period: string): Promise<AnalyticsDashboard> {
    return this.get(`/analytics/dashboard/overview?period=${period}`);
  }

  async getMonitoringDashboard(): Promise<MonitoringDashboard> {
    return this.get('/monitoring/dashboard/data');
  }
}

export const analyticsService = new AnalyticsService();